import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class ContentUtility {

  generateRandomContentIdentifier() {
    return Math.floor(Math.random() * 900) + 100;
  }

}
